export const FontSize = {
    text: '15px',
};